import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export const WithCancel = (WrappedInput) => (props) => {
    if (!props.onCancel) {
        return <WrappedInput {...props} />;
    }

    return (
        <div className="cancel-wrapper">
            <WrappedInput {...props} />

            {props.value && (
                <div className="button-cancel" onClick={props.onCancel}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
            )}
        </div>
    );
};
